"use strict";
exports.__esModule = true;
exports.SuccessNotification = exports.ErrorNotification = exports.InfoNotification = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var react_1 = tslib_1.__importDefault(require("react"));
var __1 = require("..");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        root: {
            borderRadius: 0,
            backgroundColor: function (_a) {
                var variant = _a.variant;
                return variant === 'info'
                    ? theme.palette.grey[600]
                    : theme.palette[variant].dark;
            },
            color: function (_a) {
                var variant = _a.variant;
                return theme.palette[variant].contrastText;
            }
        }
    });
});
function getAction(args) {
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(__1.IconButton, { "aria-label": "close", color: "inherit", onClick: args.onClose, size: "small" },
            react_1["default"].createElement(__1.Icon, { color: "inherit", fontSize: "small", name: "close" }))));
}
function InfoNotification(props) {
    var _a = props.visible, visible = _a === void 0 ? false : _a, children = props.children, rest = tslib_1.__rest(props, ["visible", "children"]);
    var classes = useStyles({ variant: 'info' });
    return (react_1["default"].createElement(__1.Collapse, { "in": visible },
        react_1["default"].createElement(lab_1.Alert, tslib_1.__assign({ action: getAction(props), elevation: 0, icon: false, severity: "info", variant: "filled" }, rest, { className: classes.root }), children)));
}
exports.InfoNotification = InfoNotification;
function ErrorNotification(props) {
    var _a = props.visible, visible = _a === void 0 ? false : _a, children = props.children, rest = tslib_1.__rest(props, ["visible", "children"]);
    var classes = useStyles({ variant: 'error' });
    return (react_1["default"].createElement(__1.Collapse, { "in": visible },
        react_1["default"].createElement(lab_1.Alert, tslib_1.__assign({ action: getAction(props), elevation: 0, icon: false, severity: "error", variant: "filled" }, rest, { className: classes.root }), children)));
}
exports.ErrorNotification = ErrorNotification;
function SuccessNotification(props) {
    var _a = props.visible, visible = _a === void 0 ? false : _a, children = props.children, rest = tslib_1.__rest(props, ["visible", "children"]);
    var classes = useStyles({ variant: 'success' });
    return (react_1["default"].createElement(__1.Collapse, { "in": visible },
        react_1["default"].createElement(lab_1.Alert, tslib_1.__assign({ action: getAction(props), elevation: 0, icon: false, severity: "success", variant: "filled" }, rest, { className: classes.root }), children)));
}
exports.SuccessNotification = SuccessNotification;
//# sourceMappingURL=Notification.js.map